import React from 'react';
import { Row, Col, Space } from '@oscar/theme';
import './style.scss';

interface PageHeader {
  title: string;
  subtitle?: string;
  left?: React.ReactElement;
  right?: React.ReactElement;
}

export default function Heading({ left, title, subtitle, right }: PageHeader) {
  return (
    <Row className="page-header">
      {left && (
        <Col flex="none">
          <div className="left-side">{left}</div>
        </Col>
      )}
      <Col flex="auto" className="col-title">
        <div className="heading">{title}</div>
        {subtitle && <div className="subtitle">{subtitle}</div>}
      </Col>
      {right && <Col>{right}</Col>}
    </Row>
  );
}
